export interface PackageFilterDto {
  id: string;
  name: string;
}

export interface ToolFilterDto {
  capabilityToolKey: string;
  name: string;
}

export interface ProjectUserRoleFilterDto {
  id: number;
  name: string;
}

export interface ModeFilterDto {
  id: number;
  name: string;
}

export interface AdvancedFilterOptions {
  packages: PackageFilterDto[];
  tools: ToolFilterDto[];
  projectUserRoles: ProjectUserRoleFilterDto[];
  modes: ModeFilterDto[];
}

export interface AdvancedFiltersState {
  selectedPackages: PackageFilterDto[];
  selectedTools: ToolFilterDto[];
  selectedRoles: ProjectUserRoleFilterDto[];
  selectedMode: ModeFilterDto | null;
}

export const defaultAdvancedFiltersState: AdvancedFiltersState = {
  selectedPackages: [],
  selectedTools: [],
  selectedRoles: [],
  selectedMode: null,
};

export const buildAdvancedFiltersDto = (
  filters: AdvancedFiltersState
): AdvancedFilterOptions => ({
  packages: filters.selectedPackages,
  tools: filters.selectedTools,
  projectUserRoles: filters.selectedRoles,
  modes: filters.selectedMode ? [filters.selectedMode] : [],
});

export const hasActiveAdvancedFilters = (
  f: AdvancedFilterOptions
): boolean =>
  f.packages.length > 0 ||
  f.tools.length > 0 ||
  f.projectUserRoles.length > 0;
